
  import { Component, Vue } from 'vue-property-decorator';
  import AppDialog from "@/modules/Popup/components/AppDialog.vue";
  import {httpResource} from "@/resources/http.resource";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import {bus} from "@/plugins/bus";

  @Component({
    components: {
      AppDialog
    },
  })
  export default class OfertaPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'registration', dialogName: 'ofertaPopup' };
    offer = '';
    personalAgree = false;
    confirmPrivacy = false;
    displayScrollText = true;

    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }

    async created() {
      await this.getDocument();
    }

    mounted() {
      setTimeout(() => {
        let contentBlock: any = document.querySelector('.oferta-popup .el-dialog__body');
        if (contentBlock) {
          contentBlock.addEventListener('scroll', () => {
            this.displayScrollText = contentBlock.scrollHeight - contentBlock.scrollTop - 100 > contentBlock.clientHeight;
          });
        }
      }, 0);
    }

    async getDocument() {
      let asyncAction = async () => {
        const params: any = {  };
        const {data: {result: response }} = await httpResource.httpAction({ action: 'contractOffer', params });
        this.offer = response.offer;
      };

      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    async register() {
      if (this.payloadPopup.loginMode) {
        await this.payloadPopup.loginAction();
      }
      else {
        const registrationData = this.payloadPopup.registrationData;
        let {success} = await this.$store.dispatch('auth/registrationNewUser', {registrationData});
        if (success) {
          bus.$emit(IAuth.EmitterEvents.RegistrationSuccess, registrationData);
        }
        await this.onClose();
      }
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }
  }
